// Pregledač može da zabrani localStorage (blokirani kolačići, privatni režim) ili da ga napuni (DOMException); tada sajt
// radi isto, samo ne pamti izbor između poseta. Svaka druga greška se prosleđuje dalje.
export function readStored(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    if (error instanceof DOMException) return null;
    throw error;
  }
}

export function writeStored(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    if (!(error instanceof DOMException)) throw error;
  }
}

export function removeStored(key: string): void {
  try {
    window.localStorage.removeItem(key);
  } catch (error) {
    if (!(error instanceof DOMException)) throw error;
  }
}
